import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import SkeletonText from "../../ui/skeleton/SkeletonText";

const SECTION_WIDTHS = ["40%", "55%", "35%", "50%"];

export function QualificationQuestionsSkeleton() {
  return (
    <Flex column gap={24}>
      <SkeletonText width="220px" fontSize={24} />
      {SECTION_WIDTHS.map((width, i) => (
        <SectionRow key={i}>
          <SkeletonText width={width} fontSize={18} animationDelayMs={i * 150} />
        </SectionRow>
      ))}
    </Flex>
  );
}

const SectionRow = styled(Flex)({
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: "1px solid #e5e7eb",
  paddingBottom: 24,
});
